var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiRecruitmentAssistant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "2.5 1.7 14 13.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.2,
    cy: 6.1,
    r: 2.15,
    stroke: "white",
    strokeWidth: 1.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.7C3.75 11.65 5.28 10.05 7.2 10.05C9.12 10.05 10.65 11.65 10.65 13.7",
    stroke: "white",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85 14.85H11.55",
    stroke: "white",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 2.05L13.82 3.38L15.15 3.85L13.82 4.32L13.35 5.65L12.88 4.32L11.55 3.85L12.88 3.38L13.35 2.05Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 6.05L15.9 6.75L16.6 7L15.9 7.25L15.65 7.95L15.4 7.25L14.7 7L15.4 6.75L15.65 6.05Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 8.05L11.15 8.75L11.85 9L11.15 9.25L10.9 9.95L10.65 9.25L9.95 9L10.65 8.75L10.9 8.05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiRecruitmentAssistant);
export default __webpack_public_path__ + "static/media/ai-recruitment-assistant.66ddea67e8ecf59055c43c15b07847dc.svg";
export { ForwardRef as ReactComponent };